const cache = new Map();
export function rulePattern(rule) {
  const key=JSON.stringify([rule.terms,rule.whole_word,rule.case_sensitive]);
  if(cache.has(key))return cache.get(key);
  const escaped=[...new Set(rule.terms)].filter(Boolean).sort((a,b)=>b.length-a.length).map(s=>s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'));
  let pattern=`(?:${escaped.join('|')})`;
  if(rule.whole_word)pattern=`(?<![\\p{L}\\p{N}_])${pattern}(?![\\p{L}\\p{N}_])`;
  const rx=new RegExp(pattern,rule.case_sensitive?'gu':'giu');
  if(cache.size>1000)cache.clear();cache.set(key,rx);return rx;
}
export function replacePublic(value,kind,rules=[]) {
  let result=String(value ?? '');
  for(const rule of rules){
    if(kind==='href'){
      const prefix=result.startsWith('mailto:')?'mailto:':result.startsWith('tel:')?'tel:':null;
      if(!prefix)continue;
      const index=result.indexOf('?'),body=result.slice(prefix.length,index<0?undefined:index),query=index<0?'':result.slice(index);
      const target=body.replace(rulePattern(rule),()=>rule.replace);
      const valid=prefix==='mailto:'?/^[^\s@<>"\\]+@[^\s@<>"\\]+\.[^\s@<>"\\]+$/.test(target):/^[+0-9 ().-]{3,60}$/.test(target);
      if(valid)result=prefix+target+query;
    }else result=result.replace(rulePattern(rule),()=>rule.replace);
  }
  return result;
}
